import React, { useEffect, useState, useRef, useContext } from "react";
import { Input, Col, Loading } from "../UI/general";
import { css } from "styled-components/macro";
import { Formik, Form } from "formik";
import { AddCustomerInformationSchema } from "../../configs/formSchema";
import {
  createFormInitial,
  createSendForm,
  SetDefaultValuesForLocations
} from "../../utils/form";
import { AddCustomerInformationValidationSchema } from "../../configs/validationSchemas";
import Select from "react-select-v2";
import { toast } from "react-toastify";
import { BgButton } from "../UI/register";
import lstool from "../../utils/localStorage";
import fetchModule from "../../utils/fetchingData";
import API from "./../../configs/API";
import { ModalContext } from "./../general/ModalContext";

function CustomerInfoForm(props) {
  let [isLoading, setLoading] = useState(false);
  let [initialLocations, setInitialLocations] = useState({ state: null });
  let [isNemooneKari, setNemooneKari] = useState(false);
  const setModal = useContext(ModalContext);
  let listener = useRef();
  const initalCity = async () => {
    const city = JSON.parse(lstool.get("chosenCity"));
    let cities = await fetchModule.post(
      "",
      createSendForm(
        {
          type: API.getCityFromState,
          parentid: city.state
        },
        false,
        "multiPart"
      )
    );
    const CityInfo = SetDefaultValuesForLocations(cities, city.value);
    let states = await fetchModule.post(
      "",
      createSendForm(
        {
          type: API.getState
        },
        false,
        "multiPart"
      )
    );
    const StateInfo = SetDefaultValuesForLocations(states, city.state);
    setInitialLocations({
      state: StateInfo,
      city: { options: CityInfo.options, value: CityInfo.defaultValue }
    });
  };
  const updateCityFromState = async (stateID, set) => {
    let cities = await fetchModule.post(
      "",
      createSendForm(
        {
          type: API.getCityFromState,
          parentid: stateID
        },
        false,
        "multiPart"
      )
    );
    setInitialLocations(({ state }) => {
      console.warn(state);
      return {
        state: state,
        city: { ...SetDefaultValuesForLocations(cities), value: null }
      };
    });
    set("city", "");
  };
  const ChangeCityValue = city => {
    setInitialLocations(({ state, city: prevCity }) => {
      return {
        state: state,
        city: { ...prevCity, value: city }
      };
    });
  };
  useEffect(() => {
    if (!props.location.state) {
      props.history.replace("/");
      toast.error("شماره ای گرفته نشده است!");
    }
    listener.current = props.history.listen((location, action) => {
      props.history.go(1);
    });
    initalCity();
  }, []);

  const submit = async value => {
    setLoading(true);
    const { city, secondPhoneNumber, thirdPhoneNumber, ...rest } = value;
    const { status, Phone } = props.location.state;
    let form = {
      ...rest,
      userid: lstool.get(),
      condition: isNemooneKari ? 3 : status,
      mainmobilenumber: Phone,
      customerothermobile: thirdPhoneNumber
        ? `${secondPhoneNumber},${thirdPhoneNumber}`
        : secondPhoneNumber,
      cityid: city.value,
      cityname: city.label
    };
    let response = await fetchModule.post(
      "",
      createSendForm(
        {
          type: API.completeForm,
          ...form
        },
        false,
        "multiPart"
      )
    );
    props.history.replace("/");
    listener.current();
  };
  if (!initialLocations.state) {
    return <Loading></Loading>;
  }
  return (
    <Formik
      onSubmit={submit}
      validationSchema={AddCustomerInformationValidationSchema}
      initialValues={createFormInitial(AddCustomerInformationSchema, {
        state: initialLocations.state.defaultValue,
        city: initialLocations.city.value
      })}
    >
      {({ errors, setFieldValue, submitForm }) => (
        <Form>
          <div
            css={css`
              display: flex;
              flex-flow: wrap row;
              padding: 0 5px;
            `}
          >
            <div
              css={css`
                flex: 0 0 100%;
                padding: 0 7px;
                & > h2 {
                  text-align: center;
                  font-size: 25px;
                  color: #727272;
                  letter-spacing: 2px;
                  background: #eee;
                  border-radius: 7px;
                  line-height: 50px;
                  margin: 10px 0;
                }
              `}
            >
              <h2>
                {props.location.state ? props.location.state.Phone : null}
              </h2>
            </div>
            {AddCustomerInformationSchema.map(item => {
              switch (item.type) {
                case "select":
                  const { title, name, props } = item;
                  return (
                    <Col size={100} key={name}>
                      <Select
                        styles={{
                          container: provided => ({
                            ...provided,
                            flex: "0 0 100%",
                            maxWidth: "100%"
                          }),
                          control: provided => ({
                            ...provided,
                            borderColor: errors[name] ? "red" : "var(--color1)"
                          })
                        }}
                        placeholder={title}
                        {...props}
                        {...initialLocations[name]}
                        onChange={value => {
                          if (name === "state") {
                            updateCityFromState(value.value, setFieldValue);
                          } else if (name === "city") {
                            ChangeCityValue(value);
                          }
                          setFieldValue(name, value);
                        }}
                      ></Select>
                    </Col>
                  );
                  break;

                default:
                  return (
                    <Input
                      key={item.name}
                      {...item}
                      error={errors[item.name]}
                    ></Input>
                  );
                  break;
              }
            })}
          </div>
          <div
            css={css`
              display: flex;
              flex-flow: wrap row;
              padding: 10px;
              justify-content: space-between;
            `}
          >
            <BgButton
              type="submit"
              css={css`
                flex: 0 0 50%;
                max-width: 50%;
                font-size: 16px;
                border-radius: 0px 5px 5px 0px;
              `}
              disabled={isLoading}
            >
              {isLoading ? "در حال ارسال اطلاعات" : "تایید شده"}
            </BgButton>
            <BgButton
              type="button"
              css={css`
                flex: 0 0 50%;
                max-width: 50%;
                font-size: 16px;
                background: var(--failed);
                border-radius: 5px 0px 0 5px;
              `}
              onClick={() => {
                setNemooneKari(true);
                submitForm();
              }}
            >
              {isLoading ? "در حال ارسال اطلاعات" : "نمونه کاری"}
            </BgButton>
            <BgButton
              type="button"
              css={css`
                flex: 0 0 100%;
                max-width: 100%;
                font-size: 16px;
                background-color: var(--info);
              `}
              disabled={isLoading}
              onClick={() => {
                listener.current();
                lstool.set("ReStatusNumber", props.location.state.Phone);
                props.history.goBack();
              }}
            >
              بازگشت به صفحه اصلی
            </BgButton>
          </div>
        </Form>
      )}
    </Formik>
  );
}
export default CustomerInfoForm;
